import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import s from './field.module.scss';
import DropdownIcon from '@/shared/assets/icons/dropdown-small-icon.svg';
var optionValue = function (option) {
    return typeof option === 'string' ? option : option.value;
};
var optionLabel = function (option) {
    return typeof option === 'string' ? option : option.label;
};
export var Field = function (_a) {
    var type = _a.type, _b = _a.placeholder, placeholder = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c, onChange = _a.onChange, _d = _a.options, options = _d === void 0 ? [] : _d;
    var _e = useState(false), isOpen = _e[0], setIsOpen = _e[1];
    var handleChange = function (e) {
        onChange === null || onChange === void 0 ? void 0 : onChange(e.target.value);
    };
    var handleSelect = function (option) {
        onChange === null || onChange === void 0 ? void 0 : onChange(optionValue(option));
        setIsOpen(false);
    };
    if (type === 'select') {
        var selected = options.find(function (option) { return optionValue(option) === value; });
        var display = selected ? optionLabel(selected) : value;
        return (_jsxs("div", { className: "".concat(s.wrapper, " ").concat(s.selectWrapper), children: [_jsxs("div", { className: s.selectDisplay, onClick: function () { return setIsOpen(function (prev) { return !prev; }); }, children: [display || placeholder || 'Выбрать', _jsx("span", { className: s.arrow, children: _jsx(DropdownIcon, {}) })] }), isOpen && (_jsx("div", { className: s.selectList, children: options.map(function (option) {
                        var val = optionValue(option);
                        return (_jsxs("label", { className: s.selectOption, children: [optionLabel(option), _jsx("input", { type: "radio", name: "dropdown", value: val, checked: value === val, onChange: function () { return handleSelect(option); } })] }, val));
                    }) }))] }));
    }
    var inputType = type === 'phone' ? 'tel' : type === 'email' ? 'email' : 'text';
    return (_jsx("div", { className: s.wrapper, children: _jsx("input", { className: s.input, type: inputType, placeholder: placeholder, value: value, onChange: handleChange, required: true, pattern: type === 'phone' ? '\\+?\\d{10,15}' :
                type === 'email' ? '[^@\\s]+@[^@\\s]+\\.[^@\\s]+' :
                    undefined }) }));
};
